import appsImg from "public/cloudUnifiedCom/appComs.png";

export const APPS_CONSTANTS = {
  heading: "Meet COMS—The Mobile UC App",
  description:
    "Bring your office in your pocket—powerful features for iOS, Android, Windows, and macOS built on a unified communication system.",
  list: [
    "Make and receive calls ",
    "Participate in video conferences ",
    "Send instant messages ",
    "Access voicemail and call logs ",
    "Manage contacts and settings ",
  ],
  image: appsImg,
};
